import React, { useState } from 'react'
import { showMessageBox } from '../../../../../store/actions/system.actions'
import { errorHandler } from '../../../../../services/util/error.service'
import { Btn, BtnIcon } from '../../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'
import * as colors from '../../../../../assets/js/colors'
import { FaEdit } from 'react-icons/fa'
import ModalAjusteFalta from './ModalAjusteFalta'
import ModalNovaFalta from './ModalNovaFalta'
import { formatFaltaQuantity } from './falta-volume-and-units.helper'

export default function FaltaDataTable({
  ocorrencias,
  setOcorrencias,
  getEntregaComOcorrencias,
  dispatch,
  delivery_id,
  delivery_step_id,
  nomeFantasia,
  identifier,
  modalContentClassName = '',
  modalStyle = null,
}) {
  const [showModalAjusteFalta, setShowModalAjusteFalta] = useState(false)
  const [showModalNovaOcorrencia, setShowModalNovaOcorrencia] = useState(false)
  const [selectedOcorrencia, setSelectedOcorrencia] = useState(null)
  const onModalAjusteFaltaClose = () => {
    setShowModalAjusteFalta(false)
  }

  const onModalAjusteFaltaSuccess = ocorrencia => {
    const { missing_product_id } = ocorrencia
    const index = ocorrencias.findIndex(o => o.missing_product_id === missing_product_id)
    if (index !== -1) {
      const o = [...ocorrencias]
      o[index] = ocorrencia
      setOcorrencias(o)
    }
    setShowModalAjusteFalta(false)
  }

  const onModalNovaOcorrenciaSuccess = async () => {
    await getEntregaComOcorrencias()
    setShowModalNovaOcorrencia(false)
  }

  const onModalError = error => {
    dispatch(showMessageBox(null, errorHandler(error)))
  }

  const onModalNovaOcorrenciaClose = () => {
    setShowModalNovaOcorrencia(false)
  }
  const onBtnNovoClicked = () => {
    setShowModalNovaOcorrencia(true)
  }
  const onBtnEditClicked = ocorrencia => {
    setSelectedOcorrencia(ocorrencia)
    setShowModalAjusteFalta(true)
  }

  const renderQuantity = (falta, quantity, bold) =>
    bold ? (
      <span style={{ fontWeight: 600 }}>{formatFaltaQuantity(falta, quantity)}</span>
    ) : (
      <span>{formatFaltaQuantity(falta, quantity)}</span>
    )

  return (
    <>
      <Btn minWidth={null} onClick={onBtnNovoClicked} style={{ marginBottom: '5px' }}>
        Novo
      </Btn>
      <DataTable value={ocorrencias} emptyMessage="Não existe ocorrência associada a esta entrega">
        <Column field="product_code" header="Código" style={tableCellCentered(150)} />
        <Column field="product_name" header="Produto" />
        <Column
          field="reason"
          header="Motivo"
          body={falta => {
            const { reason_sigla, reason } = falta
            return `(${reason_sigla}) ${reason}`
          }}
        />
        <Column
          field="stage"
          header="Etapa"
          style={tableCellCentered()}
          body={falta => {
            return falta.stage === 'Separacao' ? (
              <span style={{ color: colors.laranja }}>Separação</span>
            ) : (
              <span style={{ color: colors.pink }}>Entrega</span>
            )
          }}
        />
        <Column
          header="Qte Apurado"
          style={tableCellCentered(180)}
          body={falta => renderQuantity(falta, falta.qte_missing)}
        />
        <Column
          header="Qte Ajuste"
          style={tableCellCentered(180)}
          body={falta => renderQuantity(falta, falta.qte_adjusted)}
        />
        <Column
          header="Qte Sku"
          style={tableCellCentered(180)}
          body={falta => {
            const { qte_adjusted, qte_missing } = falta
            return renderQuantity(falta, Number(qte_missing) + Number(qte_adjusted || 0), true)
          }}
        />

        <Column
          header=""
          body={falta => (
            <BtnIcon onClick={() => onBtnEditClicked(falta)}>
              <FaEdit color="red" size={18} />
            </BtnIcon>
          )}
          style={{ textAlign: 'center', width: 80 }}
        />
      </DataTable>

      {showModalAjusteFalta ? (
        <ModalAjusteFalta
          falta={selectedOcorrencia}
          onModalClose={onModalAjusteFaltaClose}
          onError={onModalError}
          onSuccess={onModalAjusteFaltaSuccess}
          modalContentClassName={modalContentClassName}
          modalStyle={modalStyle}
        />
      ) : null}
      {showModalNovaOcorrencia ? (
        <ModalNovaFalta
          delivery_id={delivery_id}
          onModalClose={onModalNovaOcorrenciaClose}
          onError={onModalError}
          onSuccess={onModalNovaOcorrenciaSuccess}
          delivery_step_id={delivery_step_id}
          nomeFantasia={nomeFantasia}
          identifier={identifier}
          modalContentClassName={modalContentClassName}
          modalStyle={modalStyle}
        />
      ) : null}
    </>
  )
}
